import DepositInterestService from '../../services/DepositInterestService';
import toast from 'react-hot-toast';

// Action Types
export const DEPOSIT_INTEREST_LOADING_TOGGLE = '[DepositInterest] Loading Toggle';
export const ADD_INTEREST_PAYMENT_SUCCESS = '[DepositInterest] Add Interest Payment Success';
export const ADD_INTEREST_PAYMENT_FAILED = '[DepositInterest] Add Interest Payment Failed';
export const GET_INTEREST_PAYMENTS_SUCCESS = '[DepositInterest] Get Interest Payments Success';
export const GET_INTEREST_PAYMENTS_FAILED = '[DepositInterest] Get Interest Payments Failed';
export const GET_INTEREST_PAYMENT_BY_ID_SUCCESS = '[DepositInterest] Get Interest Payment By ID Success';
export const GET_INTEREST_PAYMENT_BY_ID_FAILED = '[DepositInterest] Get Interest Payment By ID Failed';
export const GET_INTEREST_SUMMARY_SUCCESS = '[DepositInterest] Get Interest Summary Success';
export const GET_INTEREST_SUMMARY_FAILED = '[DepositInterest] Get Interest Summary Failed';
export const GET_DEPOSITORS_FOR_INTEREST_SUCCESS = '[DepositInterest] Get Depositors For Interest Success';
export const GET_DEPOSITORS_FOR_INTEREST_FAILED = '[DepositInterest] Get Depositors For Interest Failed';
export const CALCULATE_DEPOSIT_INTEREST_SUCCESS = '[DepositInterest] Calculate Deposit Interest Success';
export const CALCULATE_DEPOSIT_INTEREST_FAILED = '[DepositInterest] Calculate Deposit Interest Failed';
export const CLEAR_DEPOSIT_INTEREST_ERRORS = '[DepositInterest] Clear Errors';
export const RESET_DEPOSIT_INTEREST_SUCCESS = '[DepositInterest] Reset Success State';

// Action Creators
export function depositInterestLoadingToggle(status) {
    return {
        type: DEPOSIT_INTEREST_LOADING_TOGGLE,
        payload: status,
    };
}

export function addInterestPaymentAction(interestData, navigate, callback) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.addInterestPayment(interestData);

            if (response && response.success === true) {
                dispatch({
                    type: ADD_INTEREST_PAYMENT_SUCCESS,
                    payload: response
                });
                dispatch(resetDepositInterestSuccess());
                if (callback && typeof callback === 'function') {
                    try { callback(response.message || 'Success', response.data || null, true); } catch (e) { /* swallow callback errors */ }
                }
                return Promise.resolve(response);
            } else {
                dispatch({
                    type: ADD_INTEREST_PAYMENT_FAILED,
                    payload: response.message || 'Failed to add interest payment'
                });
                if (callback && typeof callback === 'function') {
                    try { callback(response.message || 'Failed to add interest payment', response || null, false); } catch (e) {}
                }
                return Promise.reject(response);
            }
        } catch (error) {
            const payload = error.response?.data || { message: 'Failed to add interest payment' };
            dispatch({
                type: ADD_INTEREST_PAYMENT_FAILED,
                payload: payload.message || 'Failed to add interest payment'
            });
            if (callback && typeof callback === 'function') {
                try { callback(payload.message || 'Failed to add interest payment', payload || null, false); } catch (e) {}
            }
            return Promise.reject(error);
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getInterestPaymentsAction(params = {}) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getAllInterestPayments(params);
            dispatch({
                type: GET_INTEREST_PAYMENTS_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_INTEREST_PAYMENTS_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest payments'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getInterestPaymentByIdAction(id) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getInterestPaymentById(id);
            dispatch({
                type: GET_INTEREST_PAYMENT_BY_ID_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_INTEREST_PAYMENT_BY_ID_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest payment'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getInterestSummaryAction(params = {}) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getInterestSummary(params);
            dispatch({
                type: GET_INTEREST_SUMMARY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_INTEREST_SUMMARY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest summary'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getDepositorsForInterestAction(branchId) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getDepositorsForInterest(branchId);
            dispatch({
                type: GET_DEPOSITORS_FOR_INTEREST_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITORS_FOR_INTEREST_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch depositors'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function clearDepositInterestErrors() {
    return {
        type: CLEAR_DEPOSIT_INTEREST_ERRORS
    };
}

export function resetDepositInterestSuccess() {
    return {
        type: RESET_DEPOSIT_INTEREST_SUCCESS
    };
}

export function calculateDepositInterestAction(params) {
    return async (dispatch) => {
        try {
            const response = await DepositInterestService.calculateDepositInterest(params);
            
            if (response && response.success === true) {
                dispatch({
                    type: CALCULATE_DEPOSIT_INTEREST_SUCCESS,
                    payload: response
                });
                return Promise.resolve(response);
            } else {
                dispatch({
                    type: CALCULATE_DEPOSIT_INTEREST_FAILED,
                    payload: response.message || 'Failed to calculate interest'
                });
                toast.error(response.message || "Failed to calculate interest");
                return Promise.reject(response);
            }
        } catch (error) {
            dispatch({
                type: CALCULATE_DEPOSIT_INTEREST_FAILED,
                payload: error.response?.data?.message || 'Failed to calculate interest'
            });
            toast.error(error.response?.data?.message || 'Failed to calculate interest');
            return Promise.reject(error);
        }
    };
}